import React, {Component} from 'react';
import classNames from 'classnames';
import {ships} from './settings';
import {GlobalContext} from "./context/GlobalContext";

class ChooseShipPanel extends Component {
    render() {
        const buttons = Object.keys(ships).map((ship) => {
            const shipType = ships[ship];
            if (this.props.errorsInData[shipType] ||
                this.props.shipsAssets[shipType].iconUrl == '') {
         return null;
            } else {
                return (
                    <ShipOptionBtn
                        key={shipType}
                        isActive={this.props.activeShip === shipType}
                        ship={shipType}
                        buttonLabel={this.props.shipsAssets[shipType].iconName}
                        onClick={this.props.handleClick}
                        iconUrl={this.props.shipsAssets[shipType].iconUrl}
                    />
                )
            }
        });

        let styles = {};

        if (this.props.isCategoriesListVisible) {
            styles.visibility = 'hidden';
        }
        return (
            <div
                style={styles}
                className="ships-viewer__choose-ship-panel">
                {buttons}
            </div>
        )
    }
}

function ShipOptionBtn(props) {
    const
        buttonClasses = classNames(
            'ships-viewer__choose-ship-panel__btn',
            {
                'ships-viewer__choose-ship-panel__btn--active': props.isActive,
                'ships-viewer__choose-ship-panel__btn--3d': props.ship === ships.bulk
            }
        );

    return (
        <div className="ships-viewer__choose-ship-panel__btn-container">
            <button
                className={buttonClasses}
                type="button"
                onClick={() => props.onClick(props.ship)}>
                <img src={props.iconUrl} alt=""/>
            </button>
            <span className="ships-viewer__choose-ship-panel__label">{props.buttonLabel}</span>
        </div>
    )
}

function ChooseShipPanelWithContext(props) {
    return (
        <GlobalContext.Consumer>
            {(globalContext) => (

                <ChooseShipPanel
                    isCategoriesListVisible={globalContext.isCategoriesListVisible}
                    {...props}
                />
            )}
        </GlobalContext.Consumer>
    )
}

export default ChooseShipPanelWithContext;
